<template>
  <div class="jersey-numbers">
    <LetterNumbersStep :step="1" label="Select Style" initially-open>
      <Styles />
    </LetterNumbersStep>

    <LetterNumbersStep :step="2" label="Select Height">
      <template #action>
        <!-- prettier-ignore -->
        <span class="jersey-numbers__size-guide-link" @click.stop="toggleSizeChartModal"
        >Size Guide</span
        >
      </template>
      <Height />
    </LetterNumbersStep>

    <LetterNumbersStep :step="3" label="Select Color">
      <Color />
    </LetterNumbersStep>

    <LetterNumbersStep :step="4" label="Preview">
      <Preview />
    </LetterNumbersStep>

    <LetterNumbersStep :step="5" label="Select Quantity">
      <Quantity />
    </LetterNumbersStep>
  </div>
  <SizeChartModal v-if="isSizeChartModalOpen" @on-close="toggleSizeChartModal" />
</template>

<script setup>
import { ref } from "vue";
import LetterNumbersStep from "components/jiffy/vue-product-details-dtf/LetterNumbersStep.vue";
import Styles from "components/jiffy/vue-product-details-dtf/JerseyNumbers/Styles.vue";
import Height from "components/jiffy/vue-product-details-dtf/JerseyNumbers/Height.vue";
import Color from "components/jiffy/vue-product-details-dtf/JerseyNumbers/Color.vue";
import Preview from "components/jiffy/vue-product-details-dtf/JerseyNumbers/Preview.vue";
import Quantity from "components/jiffy/vue-product-details-dtf/JerseyNumbers/Quantity.vue";
import SizeChartModal from "components/jiffy/vue-product-details-dtf/common/SizeChartModal.vue";

const isSizeChartModalOpen = ref(false);

const toggleSizeChartModal = () => {
  isSizeChartModalOpen.value = !isSizeChartModalOpen.value;
};
</script>

<style lang="scss">
@import "frontend/init/jiffy/settings.scss";
@import "frontend/init/jiffy/mixin.scss";

@font-face {
  font-family: "Emilio 20";
  src: url("https://jiffy.imgix.net/2/fonts/emilio20.eot");
  src:
    url("https://jiffy.imgix.net/2/fonts/emilio20.eot?#iefix") format("embedded-opentype"),
    url("https://jiffy.imgix.net/2/fonts/emilio20.woff2") format("woff2"),
    url("https://jiffy.imgix.net/2/fonts/emilio20.woff") format("woff"),
    url("https://jiffy.imgix.net/2/fonts/emilio20.ttf") format("truetype"),
    url("https://jiffy.imgix.net/2/fonts/emilio20.svg#emilio20") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Emilio 19";
  src: url("https://jiffy.imgix.net/2/fonts/emilio19.eot");
  src:
    url("https://jiffy.imgix.net/2/fonts/emilio19.eot?#iefix") format("embedded-opentype"),
    url("https://jiffy.imgix.net/2/fonts/emilio19.woff2") format("woff2"),
    url("https://jiffy.imgix.net/2/fonts/emilio19.woff") format("woff"),
    url("https://jiffy.imgix.net/2/fonts/emilio19.ttf") format("truetype"),
    url("https://jiffy.imgix.net/2/fonts/emilio19.svg#emilio19") format("svg");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Facon";
  src: url("https://jiffy.imgix.net/2/fonts/facon.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Niconne";
  src: url("https://jiffy.imgix.net/2/fonts/niconne.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Beantown";
  src: url("https://jiffy.imgix.net/2/fonts/beantown.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Octin Sports";
  src: url("https://jiffy.imgix.net/2/fonts/octin_sports.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Promesh";
  src: url("https://jiffy.imgix.net/2/fonts/promesh.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Rueckwarzsalto";
  src: url("https://jiffy.imgix.net/2/fonts/rueckwarzsalto.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Soccer League";
  src: url("https://jiffy.imgix.net/2/fonts/soccer_league.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Squares Bold";
  src: url("https://jiffy.imgix.net/2/fonts/squares_bold.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

@font-face {
  font-family: "Varsity Team";
  src: url("https://jiffy.imgix.net/2/fonts/varsity_team.otf") format("opentype");
  font-weight: normal;
  font-style: normal;
  font-display: swap;
}

.jersey-numbers {
  display: flex;
  flex-direction: column;
  gap: 8px;

  &__size-guide-link {
    font-size: 14px;
    font-weight: 400;
    line-height: 16.1px;
    text-align: center;
    margin-left: 10px;
    color: $primary-600;
    text-decoration: underline;
    cursor: pointer;
  }
}
</style>
